import { render, staticRenderFns } from "./ApproveCandidateAction.vue?vue&type=template&id=4be37336&"
import script from "./ApproveCandidateAction.vue?vue&type=script&lang=js&"
export * from "./ApproveCandidateAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports